import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import BackButton from '../../../components/BackButton'
import * as S from './styles'
import SideMenuTemplate from '../templates/SideMenu'
import UseTermContent from '../../../components/UseTermContent'

const UseTerm = () => {
  const history = useHistory()
  const [isFloating, setIsFloating] = useState(false)
  const VISIBLE_HEIGHT = 150
  const BUTTON_HEIGHT = '82px'

  useEffect(() => {
    window.scrollTo(0, 0)
    window.addEventListener('scroll', () => {
      window.scrollY > VISIBLE_HEIGHT ? setIsFloating(true) : setIsFloating(false)
    })
  }, [])

  const handleBackPage = () => {
    document.body.style.removeProperty('margin-bottom')
    history.goBack()
  }

  return (
    <SideMenuTemplate>
      <S.MainContainer>
        <BackButton text='Voltar' onClick={handleBackPage}/>
        <UseTermContent />
        <BackButton text='Voltar' outline onClick={handleBackPage}/>
      </S.MainContainer>
    </SideMenuTemplate>
  )
}

export default UseTerm
